import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { DateFormat } from "@/components/atoms";

type GeneralInformationProps = {
    details: MyBrokerApi.PersonalDetails;
};

const GeneralInformation: FC<GeneralInformationProps> = ({ details = {} }) => {
    const { t } = useTranslation();
    return (
        <div>
            <div className="infoContainer">
                <span className="label">{t("Common.Title")}</span>
                <p>{details.personalTitle?.name || "-"}</p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("Common.Name")}</span>
                <p>{details.lastName || "-"}</p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("Common.FirstName")}</span>
                <p>{details.firstName || "-"}</p>
            </div>

            <div className="infoContainer">
                <span className="label">{t("Common.Gender")}</span>
                <p>{details.gender?.name || "-"}</p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("User.PersonalDetails.GeneralInformation.MaritalStatus")}</span>
                <p>{details.maritalStatus?.name || "-"}</p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("Common.BirthDate")}</span>
                <p>{details.birthdate ? <DateFormat date={details?.birthdate} /> : "-"}</p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("Common.BirthPlace")}</span>
                <p>{details.birthPlace || "-"}</p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("Common.Nationality")}</span>
                <p>{details.nationality?.name || "-"}</p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("Common.Language")}</span>
                <p>{details.language?.name || "-"}</p>
            </div>
        </div>
    );
};

export default GeneralInformation;
